export default {"src":"/_next/static/media/rating-star.ab1500c3.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};